import format from 'dateformat';
import {get} from 'lodash';
import {connect} from 'react-redux';
import {mkImageSelection} from 'ducks/coverPageImages';
import {findSection} from 'ducks/reportSections';
import CoverImages from '../lib/CoverImages';
import CoverPagePreview from './CoverPagePreview';

function coverFieldIsEnabled(
  state, field,
  coverPage = findSection(state.reportSections, state.reportType.value, 'COVER_PAGE')
) {
  return get(coverPage, `sectionData.${field}_isEnabled`, 'true') === 'true';
}

const coverField = (state, field, enabledDefault, booleanFlag = field) => {
  const coverPage = findSection(state.reportSections, state.reportType.value, 'COVER_PAGE');
  if (coverFieldIsEnabled(state, booleanFlag, coverPage)) {
    return coverPage.sectionData[field] || enabledDefault;
  }
  return null;
};

const fullName = (firstName, lastName) => {
  return [firstName, lastName].join(' ');
};

const stateToProps = (state, ownProps) => {
  const selectedImage = ownProps.selectedImage || CoverImages.selectedImage(state);

  const imageAspectRatio = CoverImages.shouldCropCoverImage(state, ownProps.name, selectedImage.src) ?
    'xMinYMin slice'
    : 'xMinYMax slice';

  const featuredImage = {
    ...selectedImage,
    imageAspectRatio,
    x: selectedImage.x ?? null,
    y: selectedImage.y ?? null,
    zoom: selectedImage.zoom || 1,
  };

  return {
    ...ownProps,
    address: coverField(state, 'singleLineAddress', state.propertyDetail.singleLineAddress),
    agencyLogo: coverField(state, 'agencyLogo', state.userDetails.agencyLogoUri),
    agent: {
      name: coverField(state, 'agentName', fullName(get(state, 'userDetails.firstName'), get(state, 'userDetails.lastName'))),
      photo: coverField(state, 'agentPhoto', state.userDetails.photo),
      tradeName: coverField(state, 'agency', state.userDetails.tradeName),
      address1: coverField(state, 'agencyAddress', fullName(get(state, 'userDetails.address1'), get(state, 'userDetails.address2'))),
      address2: coverField(state, 'agencyAddress2', [
          get(state, 'userDetails.suburb'),
          get(state, 'userDetails.state'),
          get(state, 'userDetails.postalCode'),
        ].filter(v => v).join(' '),
        'agencyAddress'
      ),
      workPhone: coverField(state, 'landline', state.userDetails.workPhoneNumber),
      mobilePhone: coverField(state, 'mobile', state.userDetails.workMobileNumber),
      workEmail: coverField(state, 'email', state.userDetails.workEmail),
    },
    featuredImage,
    resizeImageDimensions : ownProps.resizeImageDimensions,
    reportType: state.reportType.value,
    name: ownProps.name || 'half',
    showButton: ownProps.showButton || false,
    preparedFor: coverField(state, 'preparedFor') || null,
    preparedOn: coverField(state, 'preparedOn', format(new Date(), 'dS mmmm yyyy')) || null,
    title: coverField(state, 'title'),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onCoverPageLoadError: (event, reportType) => {
    dispatch(mkImageSelection({
      imageUri: null,
      invalidImage: true,
      reportType,
    }));
  }
});

export default connect(stateToProps, mapDispatchToProps)(CoverPagePreview);